import * as PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import { useLocales } from '../../../locales';
export function DonutChart({ colors, series, labels, title, details }) {
  const { translate: t } = useLocales();
  const state = {
    series,
    options: {
      labels,
      legend: {
        show: false
      },
      colors,
      dataLabels: { enabled: false },
      stroke: {
        curve: 'smooth'
      },
      plotOptions: {
        pie: {
          size: 120,
          donut: {
            size: '33%'
          }
        }
      }
    }
  };

  return (
    <div className="card rounded shadow p-6 d-flex flex-row container-fluid justify-content-around">
      <div className="p-4">
        <h1 className="mt-0 fs-2x">{t(title)}</h1>
        <Chart
          options={state.options}
          series={state.series}
          type="donut"
          height={230}
        />
      </div>

      <div className="my-2">
        <h1 className="fs-3x fw-bold  text-muted text-end">
          {Intl.NumberFormat('en-US', {
            notation: 'compact',
            compactDisplay: 'short'
          }).format(
            series.reduce((a, b) => {
              return a + b;
            }, 0)
          )}
        </h1>
        <div className="d-flex align-items-center justify-content-center">
          <div className="my-auto">
            <table className="mt-4">
              <tbody>
                {details.map((item, i) => (
                  <tr key={item.platform}>
                    <td className="p-2 me-auto text-gray-800 fw-bold text-hover-primary fs-6">
                      {t(item.platform)}
                    </td>
                    <td className="p-2 me-auto text-gray-800 fw-bold text-hover-primary fs-4">
                      {Intl.NumberFormat('en-US', {
                        notation: 'compact',
                        compactDisplay: 'short'
                      }).format(item.value)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

DonutChart.propTypes = {
  series: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired
};
